import React, { useContext, useEffect } from 'react';
import { Route, Switch, BrowserRouter, useLocation, useHistory, Redirect } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

import routes from '../constants/Routes';
import PrivateRoute from "./shared/PrivateRoute";
// import SignIn from "./sign-in/SignIn";
import Dashboard from "./dashboard/Dashboard";
import Unauthorized from "./unauthorized/Unauthorized";
import NotFound from "./not-found/NotFound";
// import UserProfile from "./user-profile/UserProfile";
import MyAssessments from "./my-assessments/MyAssessments";
// import SignUp from "./sign-up/SignUp";
import Forgot from "./forgot/Forgot";
import EditAssessmentDetails from "./edit-assessment/EditAssessmentDetails";
// import ChangePassword from "./user-profile/ChangePassword";
// import MyTelemedicineInvitation from "./my-telemedicine-invitation/MyTelemedicineInvitation";
import MySubscription from "./user-profile/subscriptions/MySubscription";
import MyExercises from "./my-exercises/MyExercises";
import MyCalendar from "./my-calendar/MyCalendar";
import MyReports from "./my-reports/MyReports";
// import leftIcon from "../assets/img/signin/leftIcon.svg";
// import doctorIcon from "../assets/img/signin/doctor-icon.svg";
// import topRoundIcon from "../assets/img/signin/topRound.svg";
// import bottomRoundIcon from "../assets/img/signin/bottomRound.svg";
import EditAssessmentOld from "./edit-assessment/EditAssessmentOld";
import EditAssessment from './editAssessmentNew/EditAssessment'
// import MyStatistics from "./my-statistics/MyStatistics";
// import TeamsEditAssessment from "./edit-assessment/team-edit-assessment/EditAssessmentOld";
import MyCards from "./my-cards/MyCards";
import CreditCardForm from "./sign-up/CreditCardForm";
import AppContext from "../contexts/AppContext";
// import {redirectTo} from "./shared/chatbotNew/ChatServices";
import ShowAllQuestions from "./show-all-questions/ShowAllQuestions";
import DeleteAccount from "./deleteAccount/DeleteAccount";
import PackageDetailsPageWrapper from "./package/PackageDetailsPageWrapper";
// import Billing from "./billing/Billing";
import Packages from "./package/PackagesPageWrapper";
import Plans from "./plans/Plans";
import useHandlePayment from "../hooks/useHandlePayment";
import GLOBAL from "../global";
import { useTenantFeatures } from "../features/tenantFeatures/useTenantFeature";
// import mmhColorLogo from "../assets/img/signin/mmhLogo.svg";
// import useRedirect from "../hooks/useRedirect";
import Callback from "./callback/Callback";
import { useHandleDirectPayment } from "../contexts/DirectPaymentContext";
import ChatBotWrapper from "./shared/chatbotNew/ChatBotWrapper";
import SignInWrapper from "./sign-in/SignInWrapper";
import SignUpWrapper from "./sign-up/SignUpWrapper";
import SNCLogin from "./SNCLogin/SNCLogin";
import WebChatComponent from "./askEmma/WebChatComponent";
import { isMobileDevice, isNSCSubdomain } from "../utils/Utils";
import { PlusIcon } from "../assets/svg/AlertModal/plus";
import { ReloadIcon } from "../assets/svg/AlertModal/reload";
import NewRegistration from "./registration/NewRegistration";
import MobileAppSuggestions from "./MobileAppSuggestions/MobileAppSuggestions";
import NewAlertModal from "./shared/AlertModal";
import AlertModal from "./AlertModal/AlertModal";
import MobileAppSuggestionsModal from "./MobileAppSuggestions/MobileAppSuggestionsModal";
import useSweetAlert from "./shared/Popups/sweetAlertComponent/useSweetAlert";
import Onboarding from "./onboarding/Onboarding";
import useDeviceCompatibility from "../hooks/useDeviceCompatibility";

const SECOND = 1000;
const MINUTES = 60 * SECOND;
const TIME_WHEN_WILL_BE_LOGOUT = 30 * MINUTES;
const PUBLIC_ROUTES = [
    routes.landing,
    routes.signIn,
    routes.signUp,
    routes.newRegistration,
    routes.forgot,
    routes.deleteAccount,
    routes.packageDetails,
    routes.plans,
    routes.packages,
    routes.billing,
    routes.unauthorized,
    routes.onboarding
];

const AppRoutesContent = () => {
    const { authenticated, deAuthenticate } = useContext(AppContext);
    const {
        handleOrderPlace,
        showAssessmentPurchaseModal,
        toggleAssessmentPurchaseModal,
        onConfirmNewAssessment,
        onCancelFollowUpAssessment,
        showMobileAppSuggestion,
        onContinueWithWeb,
        onCancelMobileAppSuggestion
    } = useHandlePayment();
    const { handleDirectPayment, clearDirectPaymentState } = useHandleDirectPayment();
    const { hideSweetAlert } = useSweetAlert();
    const location = useLocation();
    const history = useHistory();

    const InfoIcon = () => (
        <svg fill="#ffffff" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12,14a1,1,0,0,0,1-1V7a1,1,0,0,0-2,0v6A1,1,0,0,0,12,14Zm0,4a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,12,18Z" /></svg>
    );

    const { isMobileAppSuggestionEnabled, isAskEmmaEnabled, isAthleteEnabled, isSpinealignEnabled } = useTenantFeatures();
    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();
    const queryParams = new URLSearchParams(location.search);
    const hasInvGId = queryParams.get('InvGId') || queryParams.get('invgid') || queryParams.get('InvGid');

    // Update page titles dynamically based on current route
    usePageTitle(null, location.pathname);

    useEffect(() => {
        const events = ['mousemove', 'click', 'keypress', 'touchstart'];

        events.forEach(event => {
            window.addEventListener(event, updateLastActivityTime);
        });

        handleLogout();
        handleOrderPlace();

        return () => {
            events.forEach(event => {
                window.removeEventListener(event, updateLastActivityTime);
            });
        };
    }, [location.pathname, authenticated]);

    useEffect(() => {
        if (location.search) handleDirectPayment(location.search);
    }, [location.search]);

    useEffect(() => {
        const interval = setInterval(() => {
            handleLogout();
        }, SECOND * 60);

        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        // Skip inactivity timeout for Spinealign users
        if (isSpinealignEnabled) {
            return;
        }

        const lastActivity = localStorage.getItem('lastActivity');
        const now = new Date().getTime();

        if (lastActivity && (now - parseInt(lastActivity)) > TIME_WHEN_WILL_BE_LOGOUT) {
            logoutUser();
        }
    }

    const updateLastActivityTime = () => {
        const now = new Date().getTime();
        localStorage.setItem('lastActivity', now.toString());
    };

    const logoutUser = () => {
        hideSweetAlert();
        clearDirectPaymentState();
        if (!isNSCSubdomain()) {
            if (PUBLIC_ROUTES.includes(location.pathname)) {
                deAuthenticate();
            } else if (location.pathname !== "/") {
                history.push(routes.landing);
            }
        } else {
            history.push(routes.sncLogin);
        }
    };

    if (window.location.hash) return;

    return (
        <>
            {
                (isMobileAppSuggestionEnabled && isMobileDevice()) && <MobileAppSuggestions />
            }

            <Switch>

                {/*<Route exact path="/new-registration" component={NewRegistration} />*/}
                <Route exact path={routes.newRegistration} component={Onboarding} />

                {/*<Route exact path={routes.landing} component={SignIn}/>*/}
                <Route exact path={routes.landing} component={SignInWrapper} />
                {/*<Route exact path={routes.signIn} component={SignIn}/>*/}
                <Route exact path={routes.signIn} component={SignInWrapper} />
                <Route exact path={routes.signUp} component={SignUpWrapper} />
                <Route exact path={routes.forgot} component={Forgot} />
                <Route exact path={routes.deleteAccount} component={DeleteAccount} />
                <Route exact path={routes.packageDetails} component={PackageDetailsPageWrapper} />
                <Route exact path={routes.plans} component={Plans} />
                <Route exact path={routes.packages} component={Packages} />
                {/*<Route exact path={routes.billing} component={Billing}/>*/}
                {/*<Route exact path={routes.otp} component={Otp}/>*/}
                <PrivateRoute exact path={routes.dashboard} component={(isAthleteEnabled && !hasInvGId) ? () => <Redirect to={`${routes.myAssessments}/false`} /> : Dashboard} />
                {/*<PrivateRoute exact path={routes.userProfile} component={UserProfile}/>*/}
                {/*<PrivateRoute exact path={routes.changePassword} component={ChangePassword}/>*/}
                <PrivateRoute exact path={`${routes.myAssessments}/:isShowCompletedAssessments`} component={MyAssessments} />
                <PrivateRoute exact path={routes.assessment} component={EditAssessmentDetails} />
                {/*<PrivateRoute exact path={routes.myTelemedicineInvitation} component={MyTelemedicineInvitation}/>*/}
                <PrivateRoute exact path={`${routes.myExercises}/:testId`} component={MyExercises} />
                <PrivateRoute exact path={routes.mySubscription} component={MySubscription} />
                <PrivateRoute exact path={routes.myCalendar} component={MyCalendar} />
                <PrivateRoute exact path={routes.myReports} component={MyReports} />
                {/*<PrivateRoute exact path={routes.myIntake} component={MyIntake}/>*/}
                {/*<PrivateRoute exact path={routes.myDocuments} component={MyDocuments}/>*/}
                {/*<PrivateRoute exact path={routes.myPainlogs} component={MyPainlogs}/>*/}
                {/*<PrivateRoute exact path={routes.myInsight} component={MyInsight}/>*/}
                {/*<PrivateRoute exact path={routes.newScreenings} component={NewScreenings}/>*/}
                {/*<PrivateRoute exact path={routes.myMedicalHistory} component={MyMedicalHistory}/>*/}
                {/*<PrivateRoute exact path={routes.myStatistics} component={MyStatistics}/>*/}
                <PrivateRoute exact path={`${routes.editAssessmentOld}/:testId/:bodyRegionList`} component={EditAssessmentOld} />
                <PrivateRoute exact path={`${routes.editAssessment}/:testId`} component={EditAssessment} />
                <PrivateRoute exact path={`${routes.showAllQuestion}/:testId/:bodyRegionList`} component={ShowAllQuestions} />
                {/*<PrivateRoute exact path={`${routes.teamsEditAssessment}/:testId/:bodyRegionList`} component={TeamsEditAssessment}/>*/}
                <PrivateRoute exact path={`${routes.cards}`} component={MyCards} />
                <PrivateRoute exact path={`${routes.addCard}`} component={CreditCardForm} />
                <Route exact path={routes.unauthorized} component={Unauthorized} />
                <Route exact path={routes.callback} component={Callback} />
                <Route exact path={routes.sncLogin} component={SNCLogin} />
                <Route exact path={routes.onboarding} component={Onboarding} />
                <Route exact component={NotFound} />
            </Switch>

            <AlertModal
                isOpen={showAssessmentPurchaseModal}
                onClose={() => toggleAssessmentPurchaseModal()}
                icon={<InfoIcon />}
                title="What would you like to do today?"
                description={
                    <>
                        <p style={{ marginBottom: '0.75rem' }}>
                            <strong>New:</strong> Start a new assessment with a different sport selection.
                        </p>
                        <p style={{ textWrap: "wrap" }}>
                            <strong>Follow Up:</strong> Continue from your last assessment update background details if needed or go straight to biometric movement.
                        </p>
                    </>
                }
                buttons={[
                    {
                        label: 'New',
                        icon: <PlusIcon />,
                        variant: 'primary',
                        onClick: onConfirmNewAssessment,
                    },
                    {
                        label: 'Follow Up',
                        icon: <ReloadIcon />,
                        variant: 'primary',
                        onClick: onCancelFollowUpAssessment,
                    },
                ]}
                overlayClosable={false}
                showCloseButton={false}
            />

            {showMobileAppSuggestion && isMobileAppSuggestionModalEnabled && (
                <NewAlertModal
                    show={showMobileAppSuggestion}
                    confirmBtnCssClass="btn btn-sm btn-secondary"
                    confirmBtnText="Continue with web"
                    title='Device Compatibility Notice'
                    onConfirm={onContinueWithWeb}
                    showConfirm={!isMobileDevice()}
                    showCancel={false}
                    closeOnClickOutside={false}
                >
                    <MobileAppSuggestionsModal isMobileDevice={isMobileDevice()} />
                </NewAlertModal>
            )}

            {isAskEmmaEnabled && <WebChatComponent />}
        </>
    )
};

// Main component just provides the router context
const AppRoutes = () => {
    return (
        <BrowserRouter>
            <HashRedirect />
            <AppRoutesContent />
            <ChatBotWrapper />
        </BrowserRouter>
    );
};

// Remove # from URL and redirect to the clean URL
const HashRedirect = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (window.location.hash) {
            const newPath = window.location.hash.substring(1);

            const queryParams = new URLSearchParams(window.location.search).toString();
            const queryString = queryParams ? `?${queryParams}` : '';

            const newUrl = `${newPath}${queryString}`;

            history.replace(newUrl);
        }
    }, [location, history]);

    return null;
};

export default AppRoutes;
